import { Stack } from "@mui/material";
import axios from "axios";
const authInstance = axios.create({
  baseURL: "/",
  withCredentials: true,
}); 

export const AuthAPI = {
  loginUser: (user) => {
    return authInstance.request({
      method: "POST",
      url: "api/v1/auth/login",
      data: user,
    });
  },
  isAuth: () => {
    return authInstance.request({
      method: "get",
      url: "api/login",
    });
  },
  resetPassword: (userdata) => {
    return authInstance.request({
      method: "POST",
      url: "api/v1/auth/reset-password",
      data: userdata,
    });
  },
  logout: () => {
    return authInstance.request({
      method: "get",
      url: "/api/logout",
    });
  },

  sendOtp: (data) => {
    return authInstance.request({
      method: "POST",
      url: "api/v1/auth/sendOtp",
      data: data,
    });
  },

  verifyOtp: (data) => {
    return authInstance.request({
      method: "POST",
      url: "api/v1/auth/verifyOtp",
      data: data,
    });
  },

  loginSendOtp: (data) => {
    return authInstance.request({
      method: "POST",
      url: "api/v1/auth/loginSendOtp",
      data: data,
    });
  },

  loginVerifyOtp: (data) => {
    return authInstance.request({
      method: "POST",
      url: "api/v1/auth/loginVerifyOtp",
      data: data,
    });
  },
  
    getGstList: (lob) => {
    return authInstance.request({
      method: "GET",
      url: `/api/gst/gst-list/${lob}`,
    });
  },

  checkEmail: (data) => {
    return authInstance.request({
      method: "POST",
      url: "/api/gst/check-email",
      data: data,
    });
  },

  sendEmailOtp: (data) => {
    return authInstance.request({
      method: "POST",
      url: "/api/gst/send-email-otp",
      data: data,
    });
  },

  verifyEmailOtp: (data) => {
    return authInstance.request({
      method: "POST",
      url: "/api/gst/verify-email-otp",
      data: data,
    });
  },

  sendGstOtp: (data) => {
    return authInstance.request({
      method: "POST",
      url: "/api/gst/send-gst-otp",
      data: data,
    });
  },

  verifyGstOtp: (data) => {
    return authInstance.request({
      method: "POST",
      url: "/api/gst/verify-gst-otp",
      data: data,
    });
  },

  sessionStatus: () => {
    return authInstance.request({
      method: "GET",
      url: "/api/gst/session-status",
    });
  },

  getLobList: () => {
    return authInstance.request({
      method: "GET",
      url: "/api/gst/lob-list",
    });
  },

  logoutgst: () => {
    return authInstance.request({
      method: "POST",
      url: "/api/gst/logout-gst",
      withCredentials: true,
    });
  },

  gstOtpStatus: (gstin) => {
    return authInstance.request({
      method: "GET",
      url: `/api/gst/gst-otp-status/${gstin}`,
    });
  },
  
getCaptcha: (data) => {
    return authInstance.request({
      method: "POST",
      url: "api/v1/auth/getCaptcha",
      data: data,
    });
  },

  refreshCaptcha: (data) => {
    return authInstance.request({
      method: "POST",
      url: "api/v1/auth/refreshCaptcha",
      data: data,
    });
  }
};

const InvoiceInstance = axios.create({
  baseURL: "/",
  withCredentials: true,
});

export const InvoiceAPI = {
  business: (companycode) => {
    return InvoiceInstance.request({
      method: "post",
      url: "/api/supplier/business",
      data: { company_code: companycode },
    });
  },
  businessAll: (partner_code) => {
    return InvoiceInstance.request({
      method: "post",
      url: "/api/supplier/allbusiness",
      data: { partner_code: partner_code },
    });
  },
  businessGST: (gst_no) => {
    return InvoiceInstance.request({
      method: "post",
      url: "/api/supplier/businessgst",
      data: { gst_no: gst_no },
    });
  },
  getSupplier: (partner_code, business_code) => {
    return InvoiceInstance.request({
      method: "post",
      url: "/api/supplier/getsupplier",
      data: { partner_code: partner_code, business_code: business_code },
    });
  },
  getPODetails: (partner_code, business_code) => {
    return InvoiceInstance.request({
      method: "post",
      url: "/api/supplier/getpodetails",
      data: { partner_code: partner_code, business_code: business_code },
    });
  },
  uploadInvoice: (formData) => {
    return InvoiceInstance.request({
      method: "post",
      url: "/api/upload/invoice_upload",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    });
  },
  Invoices: (partner_code, business_code) => {
    return InvoiceInstance.request({
      method: "post",
      url: "/api/supplier/invoices",
      data: { partner_code: partner_code, business_code: business_code },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },

  InvoicesDraft: (invoice_id) => {
    return InvoiceInstance.request({
      method: "get",
      url: `/api/supplier/invoicesDraft?invoice_id=${invoice_id}`,
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  
   SearchInvoices: (
    Partner_Code,
    Lob,
    Gst,
    Invoice_Status,
    Invoice_Type,
    Month
  ) => {
    return InvoiceInstance.request({
      method: "post",
      url: "/api/supplier/searchinvoices",
      data: {
        partner_code: Partner_Code,
        lob: Lob,
        gst_no: Gst,
        invoice_status: Invoice_Status,
        invoice_type: Invoice_Type,
        month: Month,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },

  partnersGSTAll: (partner_code) => {
    return InvoiceInstance.request({
      method: "post",
      url: "/api/supplier/allpartnersGST",
      data: { partner_code: partner_code },
    });
  },

  updateInvoiceDraft: (formData) => {
    return InvoiceInstance.request({
      method: "post",
      url: "/api/upload/invoice_upload/draft",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    });
  },

  //   EInvoiceToken:(irnNo,gstin_no) => {
  //   return InvoiceInstance.request({
  //     method:"POST",
  //     url:"/api/einvoice/tokeneinvoice",
  //     data:{irn: irnNo},
  //     headers: {
  //       gstin: gstin_no,
  //       "Content-Type": "application/json",
  //       },
  //   })
  // },
  
  EInvoice:(irnNo,gstin_no) => {
    return InvoiceInstance.request({
      method:"POST",
      url:"/api/einvoice/geteinvoice",
      data:{irn: irnNo},
      headers: {
        gstin: gstin_no,
        "Content-Type": "application/json",
        },
    })
  },
  
    einvoiceStatus:(gst_no,business_code)=>{
    return InvoiceInstance.request({
      method:"POST",
      url:"/api/supplier/einvoiceStatus",
      data: { gst_no: gst_no, business_code: business_code},
    })
  },

    tokenRefreshEinvoice:(gstin_no)=>{
    return InvoiceInstance.request({
      method:"POST",
      url:"/api/einvoice/einvoiceTokenRefresh",
      // data:{gst_no: gst_no},
      headers:{
        gstin: gstin_no
      }
    })
  },
  
    getDepartment: (partner_code, business_code) => {
    console.log("getDepartment dbapi");
    return InvoiceInstance.request({
      method: "post",
      url: "/api/supplier/getdepartment",
      data: { partner_code: partner_code, business_code: business_code },
    });
  },
};


const TicketInstance = axios.create({
  baseURL: "/",
  withCredentials: true,
});

export const TicketAPI = {
  fetchTickets: () => {
    return TicketInstance.request({
      method: "get",
      url: "/api/tickets/list",
    });
  },

  submitTicket: (ticketData) => {
    return TicketInstance.request({
      method: "post",
      url: "/api/tickets/submit",
      data: ticketData,
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
};

const FeedbackInstance = axios.create({
  baseURL: "/",
  withCredentials: true,
});

export const FeedbackAPI = {
  submitFeedback: (data) => {
    return FeedbackInstance.request({
      method: "post",
      url: "/api/feedback/submit",
      data: new URLSearchParams(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
};

